export const DRAG_TYPE = {
  MEDIA_LIBRARY_ITEM: "MediaLibraryItem",
  DROPZONE_ITEM: "DROPZONE_ITEM",
  HEADER_COMPONENT_ITEM: "HeaderComponentItem",
  FOOTER_COMPONENT_ITEM: "FooterComponentItem",
} as const;

export const DRAG_FORMAT_UNKNOWN = "unknown";

export type ItemDragTypeKeys = keyof typeof DRAG_TYPE;

export type ItemDragType = (typeof DRAG_TYPE)[ItemDragTypeKeys];
